import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Grid,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import FemaleBodyPartSelection from "./BodyMapChild/femaleBodyPartSelection";
import MaleBodyPartSelection from "./BodyMapChild/maleBodyPartSelection";

const BodyMapBrief = ({ updateFormData, nextStep, prevStep, injured, person, images }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store
  const [uploadedImages, setUploadedImages] = useState(images || []); // State to store records
  const [selectedPerson, setSelectedPerson] = useState(person || "");
  const [injury, setInjury] = useState(injured || "No");

  const handleInjuryStatus = (event, newStatus) => {
    setInjury(newStatus);
  };

  const handleUploadedImages = (data) => {
    setUploadedImages(data);
  };

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>
        Child and Young Person Debrief
      </Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>

      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container>
        <Grid item xs={12} sm={10}>
          <Typography sx={{ fontSize: "16px", mb: 1, color: "black" }}>
            Did the young person sustain any injuries ?
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <ToggleButtonGroup value={injury} exclusive onChange={handleInjuryStatus}>
            <ToggleButton value='Yes' sx={{ textTransform: "none" }} color='primary'>
              Yes
            </ToggleButton>
            <ToggleButton value='No' sx={{ textTransform: "none" }} color='error'>
              No
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      {injury === "Yes" && (
        <>
          <Typography sx={{ mb: 2 }}>Select the Injured person</Typography>

          <TextField
            select
            fullWidth
            placeholder='Enter the name'
            variant='outlined'
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            sx={{ mb: 3 }}
          >
            <MenuItem value='Male'>Male</MenuItem>
            <MenuItem value='Female'>Female</MenuItem>
          </TextField>

          {selectedPerson === "Male" ? (
            <MaleBodyPartSelection onUpload={handleUploadedImages} />
          ) : selectedPerson === "Female" ? (
            <FemaleBodyPartSelection onUpload={handleUploadedImages} />
          ) : (
            <></>
          )}
        </>
      )}
      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button variant='outlined' color='primary' onClick={prevStep}>
          Previous
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            nextStep(); // Call the function properly
            updateFormData({ bodyMapInfo: uploadedImages, selectedPerson, injury }); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default BodyMapBrief;
